'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COLUMN_TYPE = exports.COLUMN_TYPE = 'COLUMN';
var COLUMN_DISPLAY_NAME = exports.COLUMN_DISPLAY_NAME = 'Column';
var COLUMN_DEFAULT_TITLE = exports.COLUMN_DEFAULT_TITLE = 'New Column';


//////////////////
// WEBPACK FOOTER
// ./src/common/columns/columnConstants.js
// module id = 207
// module chunks = 0